/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RackByIdPlaceResponse { 
    id: string;
    number: number;
    subnet: string;
    socketTypeId: number;
}

